import { FontSizes } from "./responsive";

export default {
  container: {
    backgroundColor: "#F0F3F9",
    flex: 1,
    position: "relative",
  },

  header: {
    flexDirection: "row",
    backgroundColor: "#fff",
    // height: 100 - StatusBar.currentHeight,
    height: 55,
    alignItems: "center",
    justifyContent: "center",
    // paddingTop: Platform.OS == 'ios' ? '5%' : 0,
    paddingVertical: 10,
  },
  declaration: {
    color: "#242833",
    fontSize: FontSizes.font16,
    fontWeight: "500",
    lineHeight: 18,
    letterSpacing: 0.5,
    paddingTop: 11,
    paddingLeft: 12,
    paddingRight: 12,
    paddingBottom: 11,
    fontFamily: "SFProDisplay-Medium",
  },
  loginHeader: {
    height: "35%",
    alignItems: "center",
    justifyContent: "center",
  },

  categoryHeader: {
    flex: 0.2,
    width: "100%",
    flexDirection: "row",
    paddingTop: "8%",
    marginStart: "5%",
  },

  blogHeader: {
    alignSelf: "stretch",
    flex: 0.1,
    alignItems: "flex-end",
    marginTop: "8%",
    flexDirection: "row",
  },

  headerRowChild: {
    flex: 1,
    width: "100%",
    marginHorizontal: "5%",
    alignItems: "center",
    flexDirection: "row",
  },

  blogHeaderRowChild: {
    flex: 1,
    width: "100%",
    alignItems: "center",
    flexDirection: "row",
    marginTop: 21,
    marginHorizontal: "5%",
  },

  title: {
    fontSize: FontSizes.font16,
    textAlign: "center",
    fontFamily: "SFProDisplay-Bold",
    flex: 1,
  },

  body: {
    flex: 0.8,
    marginHorizontal: "5%",
  },

  headerBackButtonView: {
    position: "absolute",
    left: 0,
  },
  backButtonView: {
    flex: 20,
  },
  blankView: {
    flex: 20,
  },

  backButton: {
    width: 30,
    height: 30,
    marginLeft: 10,
  },

  btn: {
    width: "88%",
    backgroundColor: "#0659FD",
    borderRadius: 12,
    height: 50,
    marginBottom: 5,
    alignItems: "center",
    justifyContent: "center",
    marginHorizontal: 25,
  },

  updateBtn: {
    backgroundColor: "#0659FD",
    borderRadius: 12,
    marginHorizontal: "22.4%",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "10%",
    paddingVertical: 19,
  },

  greenTick: {
    height: 18,
    width: 18,
  },
  modal: {
    position: "relative",
    flex: 1,
    backgroundColor: "#ffffff",
    marginTop: "80%",
    borderRadius: 20,
  },
  modalAddChild: {
    position: "relative",
    height: "37%",
    backgroundColor: "#ffffff",
    marginTop: "80%",
    borderRadius: 20,
  },
  buttonView: {
    alignSelf: "flex-end",
    flexDirection: "row",
  },
  cancelButtonTextStyle: {
    fontFamily: "Nunito-Sans",
    color: "#0659FD",
    fontSize: FontSizes.font14,
    lineHeight: 20,
    fontWeight: "bold",
    textAlign: "center",
  },

  cancelButtonStyle: {
    width: "20%",
    borderRadius: 12,
    height: 50,
    alignItems: "center",
    justifyContent: "center",
    marginTop: "10%",
    marginHorizontal: 25,
  },

  updateButtonTextStyle: {
    fontFamily: "SFProDisplay-Medium",
    color: "white",
    fontSize: FontSizes.font12,
  },

  updateButtonStyle: {
    width: "30%",
    backgroundColor: "#0659FD",
    borderRadius: 9,
    height: 40,
    alignItems: "center",
    justifyContent: "center",
    marginTop: "10%",
  },
  textInputView: {
    height: 50,
    marginTop: 10,
    borderColor: "#8F92A1",
    borderWidth: 1.2,
    borderRadius: 4,
  },
  inputText: {
    height: 50,
    color: "black",
    paddingLeft: 10,
    borderWidth: 0,
    fontFamily: "SFProDisplay-Medium",
  },
  modal_text: {
    fontFamily: "SFProDisplay-Light",
    fontSize: FontSizes.font12,
    color: "#8F92A1",
    marginTop: 5,
  },
  welcome_title: {
    fontFamily: "SFProDisplay-Bold",
    fontSize: FontSizes.font16,
    color: "#1E1F20",
    fontWeight: "bold",
  },
  msgParent_old: {
    fontSize: FontSizes.font16,
    lineHeight: 20,
    fontStyle: "normal",
    fontFamily: "SFProDisplay-Medium",
    color: "#1E1F20",
  },
  msgParent: {
    fontSize: FontSizes.font14,
    fontFamily: "SFProDisplay-Light",
    color: "#1E1F20",
  },

  whiteLightText: {
    fontFamily: "NunitoSans-Light",
    color: "#fff",
  },
  blackLightText: {
    fontFamily: "NunitoSans-Light",
    color: "#313131",
  },
  whiteMediumText: {
    fontFamily: "NunitoSans-SemiBold",
    color: "#fff",
  },
  blackMediumText: {
    fontFamily: "NunitoSans-SemiBold",
    color: "#313131",
  },

  whiteBoldText: {
    fontFamily: "NunitoSans-Bold",
    color: "#fff",
  },
  whiteExtraBoldText: {
    fontFamily: "NunitoSans-ExtraBold",
    color: "#fff",
  },
  blackBoldText: {
    fontFamily: "NunitoSans-Bold",
    color: "#313131",
  },
  blackExtraBoldText: {
    fontFamily: "NunitoSans-ExtraBold",
    color: "#313131",
  },
  whiteRegularText: {
    fontFamily: "NunitoSans-Regular",
    color: "#fff",
  },
  blackRegularText: {
    fontFamily: "NunitoSans-Regular",
    color: "#313131",
  },
  shadow: {
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 0.2,
    shadowRadius: 1.41,
    elevation: 2,
  },
};
